export var AUTH_COOKIE = '_animatronauth';
export var ANON_USER_COOKIE = 'animatron:user:is-anon';
export var SECURE_TOKEN_HEADER_NAME = 'Animatron-Security-Token';
export var GUEST_ID_HEADER_NAME = 'Guest-ID';
export var ANM_LOCAL_STORAGE = 'animatron:state';
export var STREAM_LOCAL_STORAGE = 'animatron:stream:state';